import {Vehicle} from "@commons/models/domain/Vehicle";

export class VehicleLocationProcessor {
  setVehiclesLocation(updatedData: any, vehicle: Vehicle) {
    // wyszukanie w kontrolkach tych wlasciwych
    vehicle.ControlIndicators = vehicle.ControlIndicators || [];
    const geoIndicator = vehicle.ControlIndicators.find((i: any) => {
      return i.Tp == 8;
    });

    const lat = parseFloat((updatedData.Data.Lt || '').replace(',', '.'));
    const lon = parseFloat((updatedData.Data.Ln || '').replace(',', '.'));

    // ostatni czas z lokalizacji - nie wiem dlaczego - MCW-296
    if (updatedData.Data.LT) {
      vehicle.LastUpdated = updatedData.Data.LT;
      vehicle.LastUpdatedFrom = 'WS_DATA_2_GEO';
    }
    if (geoIndicator) {
      // aktualizacja parametrow
      geoIndicator.LV.T = updatedData.Data.LT;
      geoIndicator.LV.V = {Lat: lat, Lon: lon};
    }

    const location = vehicle.LL;

    if (location) {
      // DegeoInfo
      location.City = updatedData.Data.City ? updatedData.Data.City : location.City;
      location.Cr = updatedData.Data.Cr ? updatedData.Data.Cr : location.Cr;
      location.Ct = updatedData.Data.Ct ? updatedData.Data.Ct : location.Ct;
      location.Ds = updatedData.Data.Ds ? updatedData.Data.Ds : location.Ds;
      location.Hs = updatedData.Data.Hs ? updatedData.Data.Hs : location.Hs;
      location.Rd = updatedData.Data.Rd ? updatedData.Data.Rd : location.Rd;
      location.St = updatedData.Data.St ? updatedData.Data.St : location.St;
      location.Zp = updatedData.Data.Zp ? updatedData.Data.Zp : location.Zp;

      vehicle.LL = location;
    }
  }
}
